import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
   // tslint:disable-next-line:directive-selector
   selector: 'am-edit-grievance-button'
})
export class EditGrievanceButtonUpgradedDirective extends UpgradeComponent {
   @Input() grievanceId: any;
   @Output() refresh: EventEmitter<any>;

   constructor(elementRef: ElementRef, injector: Injector) {
      super('amEditGrievanceButton', elementRef, injector);
   }
}
